import React from 'react';
import './Header.css';
import HeaderTitle from '../HeaderTitle/HeaderTitle';

const Header = () => {
 
    return (
        <section className="header-container">
            <HeaderTitle></HeaderTitle>
        </section>
    );
};

export default Header;